<template>
  <v-layout column>
    <v-layout>
      <v-layout column class="full-height" :class="{ 'max-width-190': !isPaid && mdAndUp }">
        <v-layout align-center>
          <amount-badge :amount="quantity" persistent class="mr-2 amount-badge" />
          <span class="order-line-name primary--text text--darken-1">{{ orderLine.name }}</span>
          <v-spacer/>
        </v-layout>
        <span class="grey--text text--darken-1 caption">
          {{ modifierOptionOrderLines.map(oL => oL.name).join(', ') }}
        </span>
      </v-layout>
      <v-layout column align-end justify-center>
        <div v-for="(price, i) in priceArray" :key="i"
          :set1="discountedAmount = getPriceDiscountedAmount(price)"
          :set2="currency = getCurrency(price)"
          :set3="amount = (price.amount + discountedAmount + (isPaid ? 0 : modifierAmount)) * orderLine.quantity"
          class="text-right"
          :class="{
            'red--text': !orderLine.price.length
          }">
          <v-layout v-if="price.amount" column :class="{ 'line-through': discountOrderLines.length }">
            {{ getPriceString({ amount, currency: currency }) }}
            <span v-if="showDisplayCurrency" class="grey--text" :class="{ 'line-through-grey': discountOrderLines.length }">
              {{ getPriceString({ amount, currency: currency, displayCurrency: displayCurrency }) }}
            </span>
          </v-layout>
          <v-layout column v-if="discountedAmount">
            (-{{ getDiscountValue(price) }}%) {{ getPriceString({ amount, currency: currency }) }}
            <span v-if="showDisplayCurrency" class="grey--text">
              {{ getPriceString({ amount, currency: currency, displayCurrency: displayCurrency }) }}
            </span>
          </v-layout>
        </div>
        <v-layout justify-end v-if="!isPaid && orderLine.itemEntity === PRODUCT">
          <span style="text-decoration-line: underline; font-size: 15px;"
            @click="$store.commit('cart/removeProductInCart', { productId: orderLine.itemId, optionIds: modifierOptionOrderLines.map(oL => oL.itemId) })"
            class="clickable">
            {{ $t("catalog.remove") }}
          </span>
        </v-layout>
      </v-layout>
    </v-layout>
    <v-divider v-if="isPaid && !lastOrderLine" class="my-2" />
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { orderLineTypes, orderLineItemEntities, currencyTypes } from '@/config'

import moneyMixins from '@/mixins/MoneyFormat'
import vuetifyMixins from '@/mixins/Vuetify'

const { CATALOG_PRODUCT_MODIFIER_OPTION } = orderLineItemEntities

export default {
  props: {
    isPaid: Boolean,
    orderLine: Object,
    orderLines: Array,
    currencies: Array, // Finds currency if not decorated
    lastOrderLine: Boolean,
  },
  mixins: [
    moneyMixins,
    vuetifyMixins,
  ],
  data () {
    return {
      PRODUCT: orderLineItemEntities.PRODUCT,
      LEGAL: currencyTypes.LEGAL,
    }
  },
  computed: {
    ...mapState({
      account: (state) => state.accounts.account,
    }),
    ...mapGetters('me', ['getPriceString', 'showDisplayCurrency', 'displayCurrency']),
    quantity () {
      return this.orderLine.quantity
    },
    discountOrderLines () {
      return this.orderLines ? this.orderLines.filter(oL => {
        return (
          oL.id !== this.orderLine.id &&
          oL.parentOrderLine === this.orderLine.id &&
          oL.orderLineType === orderLineTypes.DISCOUNT
        )
      }) : []
    },
    priceArray () {
      return this.orderLine.price.length ? this.orderLine.price : []
    },
    modifierOptionOrderLines () {
      return this.orderLines.filter(({ parentOrderLine, itemEntity }) => parentOrderLine === this.orderLine.id && itemEntity === CATALOG_PRODUCT_MODIFIER_OPTION)
    },
    modifierAmount () {
      return this.modifierOptionOrderLines.reduce((acc, orderLine) => {
        return acc + orderLine.price[0].amount
      }, 0)
    },
  },
  methods: {
    getCurrency (price) {
      return price.currency || (
        this.currencies
          ? this.currencies.find(c => c.id === price.currencyId)
          : this.account.currencies.find((c) => c.id === price.currencyId)
      )
    },
    getPriceDiscountedAmount (price) {
      let discountedAmount = 0
      this.discountOrderLines.forEach((discountOrderLine) => {
        const discountForPriceItem = discountOrderLine.price.find((discountPriceItem) => {
          return discountPriceItem.currencyId === price.currencyId
        })
        if (discountForPriceItem) {
          discountedAmount += Math.abs(discountForPriceItem.amount) * discountOrderLine.quantity
        }
      })
      return discountedAmount
    },
    getDiscountValue (price) {
      let value = 0
      this.discountOrderLines.forEach((discountOrderLine) => {
        const discountForPriceItem = discountOrderLine.price.find((discountPriceItem) => {
          return discountPriceItem.currencyId === price.currencyId
        })
        if (discountForPriceItem) {
          value += Math.abs(discountOrderLine.value)
        }
      })
      return value
    },
  },
  components: {
    AmountBadge: () => import('@/components/view-components/catalog/AmountBadge.vue'),
  },
}
</script>

<style lang="scss" scoped>
.order-line-name {
  font-weight: bold;
  font-size: 18px;
}
.line-through-grey {
  text-decoration: line-through;
  text-decoration-color: grey;
}
.amount-badge {
  max-height: 27px;
}
.max-width-190 {
  max-width: 190px;
}
</style>
